
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const ServicesSection = () => {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-2 text-fabre-gray">
            Nos Solutions
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-6"></div>
          <p className="text-lg text-fabre-darkteal max-w-2xl mx-auto">
            Des solutions adaptées à chaque besoin
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Professionnels */}
          <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-[400px] border border-fabre-green/20">
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-110"
              style={{ 
                backgroundImage: `linear-gradient(135deg, rgba(140, 198, 63, 0.8), rgba(56, 94, 113, 0.8)), url('https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d')` 
              }}
            ></div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
              <h3 className="text-2xl font-heading font-bold mb-2">Professionnels</h3>
              <p className="mb-4 opacity-90">
                Solutions sur-mesure pour les industries et entreprises
              </p>
              <Button asChild className="bg-white text-fabre-green hover:bg-fabre-lightgreen hover:text-fabre-darkgreen w-full mt-2 font-semibold">
                <Link to="/services/professionnels">Découvrir</Link>
              </Button>
            </div>
          </div>
          
          {/* Collectivités */}
          <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-[400px] border border-fabre-teal/20">
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-110"
              style={{ 
                backgroundImage: `linear-gradient(135deg, rgba(98, 146, 158, 0.8), rgba(140, 198, 63, 0.8)), url('https://images.unsplash.com/photo-1605810230434-7631ac76ec81')` 
              }}
            ></div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
              <h3 className="text-2xl font-heading font-bold mb-2">Collectivités</h3>
              <p className="mb-4 opacity-90">
                Gestion optimisée des déchets pour les territoires
              </p>
              <Button asChild className="bg-white text-fabre-teal hover:bg-fabre-lightgreen hover:text-fabre-darkteal w-full mt-2 font-semibold">
                <Link to="/services/collectivites">Découvrir</Link>
              </Button>
            </div>
          </div>
          
          {/* Particuliers */}
          <div className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 h-[400px] border border-fabre-gold/20">
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-300 group-hover:scale-110"
              style={{ 
                backgroundImage: `linear-gradient(135deg, rgba(227, 178, 60, 0.8), rgba(98, 146, 158, 0.8)), url('https://images.unsplash.com/photo-1649972904349-6e44c42644a7')` 
              }}
            ></div>
            <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
              <h3 className="text-2xl font-heading font-bold mb-2">Particuliers</h3>
              <p className="mb-4 opacity-90">
                Services de proximité pour tous vos besoins
              </p>
              <Button asChild className="bg-white text-fabre-gold hover:bg-fabre-beige hover:text-fabre-darkteal w-full mt-2 font-semibold">
                <Link to="/services/particuliers">Découvrir</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
